// extracted by mini-css-extract-plugin
export default {"control":"Radio__control--1b3","content":"Radio__content--3Ef"};